import {eye} from 'assets/images/images';
import {DashboardLayout, TableLayout} from 'components';
import Breadcrumbs from 'components/BreadCrumbs';
import CardSummary from 'components/CardSummary';
import * as Actions from '../../store/actions';
import {PAGES_URL} from 'helpers/constants';
import {connect} from 'react-redux';
import React, {useState} from 'react';
import InvoiceDetailsModal from './components/InvoiceDetailsModal';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import {getStatusTextAndStyles} from 'helpers/getStatusTextAndStyles';

function VeldroSingleBusiness({auth: {userDetails}}) {
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';

  const [invoiceDetails, setInvoiceDetails] = useState(false);
  const lighterShadeDeep = getLighterShade(baseColor, 90);

  const toggleInvoiceModal = () => setInvoiceDetails(prevState => !prevState);

  const tableHeader = [
    {label: 'IRN', key: 'irn'},
    {label: 'Issue Date', key: 'issue_date'},
    {label: 'Due Date', key: 'due_date'},
    {label: 'Status', key: 'status'},
    {label: 'Action', key: 'action'},
  ];

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Businesses</p>
      }
    >
      {' '}
      <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mr-[-24px] ml-[-32px] px-8 border border-transparent border-b-[#E4E3E6]">
        <Breadcrumbs
          items={[
            {label: 'Businesses', path: PAGES_URL.VELDRO_BUSINESSES},
            {label: 'Test Business'},
          ]}
        />
      </div>
      <div className="flex items-center py-2 flex-wrap gap-3 mx-[-32px] px-8 border border-transparent border-b-[#E4E3EC]">
        <>
          <div
            style={{
              backgroundColor: lighterShadeDeep,
              borderColor: 'rgba(230, 240, 255, 0.5)',
            }}
            className="min-h-[63px] flex items-center justify-center min-w-[63px] rounded-full"
          >
            <h3 className="text-[32px] font-medium text-brandBlue">TB</h3>
          </div>
          <div className="flex flex-col gap-1">
            <h4 className="text-grey font-medium text-[20px]">Test Business</h4>
            <p className="text-sm font-medium text-[#868C98]">
              testbusiness@gmail.com
            </p>
            <span className="rounded-full w-fit px-[8px] py-[4px] bg-[#F3FCF1]">
              <h5 className="font-medium text-[10px] text-[#3FB12C]">
                6df03c76-1d83-4a39-a4de-51bd70547aef
              </h5>
            </span>
          </div>
        </>
      </div>
      <div className="grid md:grid-cols-3 gap-4 h-full my-6">
        <CardSummary title="Total Invoices" body="1" />
        <CardSummary title="Completed Invoices" body="0" />
        <CardSummary title="Pending Invoices" body="1" />
      </div>
      <InvoiceDetailsModal show={invoiceDetails} onClose={toggleInvoiceModal} />
      <TableLayout negativeMargins>
        <thead className="font-semibold uppercase">
          <tr className="bg-white80">
            {tableHeader.map(({label, key}) => (
              <th
                key={key}
                className={`${
                  label === 'IRN' ? 'pl-4 sm:pl-6 xl:pl-8' : 'pl-0'
                } h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap`}
              >
                <div className="flex items-end gap-1 cursor-pointer">
                  <span>{label}</span>
                </div>
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody className="text-sm bg-white">
          <tr
            onClick={toggleInvoiceModal}
            className="border-[0.5px] border-[#E4E3EC] cursor-pointer"
          >
            <td className="p-4 pl-4 sm:pl-6 xl:pl-8 text-body whitespace-nowrap capitalize">
              INV002123-94ND90NR-20250611
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              11th June 2025
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              18th June 2025
            </td>
            <td className="p-4 pl-0 text-body whitespace-nowrap">
              <span
                className={`uppercase py-1 px-2 text-[10px] rounded-full ${
                  getStatusTextAndStyles('pending').styles
                }`}
              >
                {getStatusTextAndStyles('pending').text || '-'}
              </span>
            </td>

            <td className="p-4 pl-0 whitespace-nowrap">
              <button title="View" className="h-4 aspect-square">
                <img src={eye} alt="View" />
              </button>
            </td>
          </tr>
        </tbody>
      </TableLayout>
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(VeldroSingleBusiness);
